import React from 'react';
require('../../scss/style.scss');
import MDSpinner from "react-md-spinner";

const KeolisSpinner = (props) => (
    <div className="loadingSpinnerDiv">
        <span className="animated zoomIn infinite loadingKeolisIcon">K</span>
        <MDSpinner size={40}/>
    </div>
);

export default KeolisSpinner;
